export function initCardImageSlider() {
    document.querySelectorAll('[id^="kn_card_image_slider_"]').forEach(slider => {
        const slides = slider.querySelectorAll('.kn_card-image-slider__slide');
        const dots = slider.closest('.kn_card-image-slider__container').querySelectorAll('.kn_card-image-slider__dot');

        function setActiveSlide(index) {
            // Remove active class and unwrap any existing a tags
            slides.forEach(s => {
                s.classList.remove('active');
                if (s.parentElement.tagName === 'A') {
                    s.parentElement.replaceWith(s);
                }
            });

            // Add active class and wrap with a tag
            slides[index].classList.add('active');
            const wrapper = document.createElement('a');
            const linkWrapper = slides[index].querySelector('.kn_card-image-slider__link-wrapper');
            wrapper.href = linkWrapper ? linkWrapper.getAttribute('href') : '#';
            slides[index].parentNode.insertBefore(wrapper, slides[index]);
            wrapper.appendChild(slides[index]);

            // Get the wrapper element that has the horizontal scroll
            const scrollWrapper = slides[index].closest('.kn_card-image-slider__wrapper');
            const slideOffset = slides[index].offsetLeft;
            const wrapperWidth = scrollWrapper.offsetWidth;
            const scrollPosition = slideOffset - (wrapperWidth / 2) + (slides[index].offsetWidth / 2);

            scrollWrapper.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });
        }

        function setActiveDot(index) {
            dots.forEach(d => d.classList.remove('active'));
            dots[index].classList.add('active');
        }

        slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                setActiveSlide(index);
                setActiveDot(index);
            });
        });

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                setActiveSlide(index);
                setActiveDot(index);
            });
        });
    });
}
